import { FormLabel } from '../../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Control, Controller } from 'react-hook-form';
import { Select } from 'antd';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { useCallback, useMemo } from 'react';
import { SelectOption } from 'types/base';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';

const Stamp = ({
  control,
  index,
  required,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  required?: boolean;
}) => {
  const { stampSelectOptions } = useAppSelector(selectGlobalInfo);
  const stampListSort = useMemo((): SelectOption[] => {
    if (stampSelectOptions && stampSelectOptions.length) {
      return [...stampSelectOptions].sort(
        (a: SelectOption, b: SelectOption) => b.sort! - a.sort!
      );
    }
    return [];
  }, [stampSelectOptions]);
  const SelectFilter = useCallback(
    (input: string, option: SelectOption | undefined) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
    []
  );
  return (
    <div className="flex items-center gap-2">
      <FormLabel required={required}>{i18n.t(LOCALS.stamp)}:</FormLabel>
      <Controller
        name={`productList.${index}.stamp`}
        control={control}
        render={({ field, formState: { errors } }) => (
          <Select
            {...field}
            className="w-full"
            status={errors.productList?.[index]?.stamp ? 'error' : undefined}
            options={stampListSort}
            filterOption={SelectFilter}
            placeholder={i18n.t(LOCALS.please_select) || ''}
            showSearch
            onChange={(value) => {
              field.onChange(value);
            }}
          />
        )}
      />
    </div>
  );
};

export default Stamp;
